const state = {
    user: {
        guest: true,
        addresses: []
    },
    selectedAddress: null,
    legacyCurrency: false,
};


const getters = {
    addresses: state => state.user.addresses,
    addressByType: state => type => [state.user.addresses.find(address => address.type === type)],
    defaultAddressByType: state => type => state.user.addresses.find(address => !!address.default && address.type === type),
    user: state => state.user,
    /**
     * Needs refactoring away from type
     * @param state
     * @param getters
     * @returns {function(*=): (*|__webpack_exports__.default.props.selectedAddress|{required, default}|state.selectedAddress|{billing, delivery})}
     */
    selectedAddressByType: (state, getters) => type => state.selectedAddress || getters.defaultAddressByType(type),

    loggedIn: state => state.user.guest === undefined ? true : false,

    pendingUpgrade: state => state.user.pending_upgrade,

    hasPendingUpgrade: (state, getters) => getters.pendingUpgrade && getters.pendingUpgrade.cancelled_at === null,

    hasFailedUpgrade: state => state.user.has_failed_upgrade,

    hasMultipleFailuresInTheLastDay: state => state.user.has_multiple_failures_in_the_last_day,

    region: state => state.user.region,
};

const actions = {
    createAddress({commit}, address) {
        commit('addAddress', address);
    },
    useAddress({commit}, address) {
        commit('selectAddress', address)
    }
};

const mutations = {
    updateUser: (state, data) => {
        state.user = data;
    },
    setName: (state, name) => {
        state.user.name = name;
    },
    selectAddress: (state, address) => {
        state.selectedAddress = address;
    },
    addAddress: (state, address) => {
        state.user.addresses.push(address);
    },
    removeAddress: (state, address) => {
        state.user.addresses = state.user.addresses.filter(stateAddress => {
            return stateAddress.id !== address.id;
        })
    },
    updateAddress: (state, data) => {
        let addresses = state.user.addresses;
        let index = addresses.indexOf(data.old);
        addresses.splice(index, 1, data.new);
    },
    canChangeCountry: (state, canChangeCountry) => {
        state.user.canChangeCountry = canChangeCountry;
    },
    legacyCurrency: (state, legacyCurrency) => {
        state.legacyCurrency = legacyCurrency;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
}
